import { Injectable }           from "@angular/core";
import { Http }                 from "@angular/http";

import { CONSTANT }           from "../../_custom";
import "rxjs/add/operator/toPromise";

@Injectable()
export class CtmConstantService {
    constructor(private http: Http) {}

    public initialConstant(): Promise<Object>{
        return this.http.get(`assets/constant.json`)
        .toPromise()
        .then((res) => {
            let cobj = res.json();
            for(let prop in cobj)
            {
                CONSTANT[prop] = cobj[prop]
            }
            return true;
        })
    }
}


// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/_custom/services/constant.service.ts